import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Button } from 'react-bootstrap';
import { getOrgTermsContent } from '../../content/utils.js';
import FlagIcon from '../icons/FlagIcon.jsx';
import { TriangleBlueIcon } from '../icons/TriangleBlueIcon.jsx';

const MilestoneCard = ({
  handleShowEditForm,
  mile,
  archived,
  canManage = true,
}) => {
  const { name, notes, date_at } = mile;
  const [isShowMore, setIsShowMore] = useState(false);
  const [isShowMoreBtnNeed, setIsShowMoreBtnNeed] = useState(false);

  useEffect(() => {
    const viewNote = document.getElementById(name);
    if (viewNote && viewNote.scrollHeight > viewNote.clientHeight) {
      setIsShowMoreBtnNeed(true);
    }
  }, []);

  return (
    <div className="milestone-card m-t-28">
      <div
        style={{
          display: 'flex',
          flex: '1',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <h4 className="flex m-b-16">
          <div
            className="flex header-item bordered m-r-8"
            style={{ borderColor: mile.project_id ? '#27B0E0' : '#5771CA' }}
          >
            <FlagIcon fill={mile.project_id ? '#27B0E0' : '#5771CA'} />
          </div>
          {name}
        </h4>
        {canManage ? (
          <React.Fragment>
            {archived ? (
              <Button
                type="button"
                className="btn-edit"
                onClick={() =>
                  window.alert(getOrgTermsContent('archivedProjectMessage'))
                }
              >
                Edit
              </Button>
            ) : (
              <Button
                type="button"
                className="btn-edit"
                onClick={() => handleShowEditForm(mile)}
              >
                Edit
              </Button>
            )}
          </React.Fragment>
        ) : null}
      </div>

      <h6 className="m-b-16">{moment(date_at).format('MM/DD/YYYY')}</h6>
      {notes?.length ? (
        <div
          id={name}
          className={!isShowMore && 'notes'}
          style={{ color: '#7F8FA4' }}
        >
          {notes}
        </div>
      ) : null}
      {isShowMoreBtnNeed ? (
        <Button
          aria-label={isShowMore ? 'Show More' : 'Show Less'}
          type="button"
          onClick={() => setIsShowMore(!isShowMore)}
          className="flex flex-align-center btn-link px-0"
        >
          {!isShowMore ? (
            <span className="flex flex-align-center">
              <span className="m-r-8">Show More</span>
              <TriangleBlueIcon
                style={{ height: '20px' }}
                transform="rotate(180)"
              />
            </span>
          ) : (
            <span className="flex flex-align-center">
              <span className="m-r-8">Hide</span>
              <TriangleBlueIcon style={{ height: '20px' }} />
            </span>
          )}
        </Button>
      ) : null}
    </div>
  );
};

export default MilestoneCard;
